import { IconButton, InputAdornment, SvgIcon } from '@mui/material';
import type React from 'react';
import { useTranslation } from 'react-i18next';

import getMuiIcon from '../../../utils/getMuiIcon';
import { SEARCH_ICON_VIEW_BOX, searchIconSx } from '../../../utils/searchInputStyles';

interface SearchEndAdornmentProps {
	value?: string;
	onSearch: () => void;
	onClear: () => void;
}

const SearchEndAdornment: React.FC<SearchEndAdornmentProps> = ({ value, onSearch, onClear }) => {
	const { t } = useTranslation();

	return (
		<InputAdornment position="end">
			{value && (
				<IconButton
					onClick={onClear}
					data-testid="search-bar-clear-button"
					aria-label={t('Clear search')}
					type="button"
				>
					<SvgIcon component={getMuiIcon('close')} sx={searchIconSx} aria-hidden="true" />
				</IconButton>
			)}
			<IconButton
				onClick={onSearch}
				data-testid="search-bar-search-button"
				aria-label={t('Search')}
				type="button"
			>
				<SvgIcon
					component={getMuiIcon('search')}
					sx={searchIconSx}
					viewBox={SEARCH_ICON_VIEW_BOX}
					aria-hidden="true"
				/>
			</IconButton>
		</InputAdornment>
	);
};

export default SearchEndAdornment;
